import { types } from 'mobx-state-tree';

import PaymentModule from '../../../PaymentModule';
import Price from '../../../Price';

const PaymentMethod = types.compose(
  PaymentModule,
  types.model('PaymentMethod', {
    denied_message: types.maybeNull(types.string),
    description: types.maybeNull(types.string),
    id: types.identifier,
    is_denied: types.boolean,
    price: types.maybeNull(Price),
    product_id: types.maybeNull(types.string),
    supports_tokenization: types.boolean,
    tax_class: types.maybeNull(types.number),
    parent_group_type: types.optional(types.string, 'CUSTOM'),
  })).named("PaymentMethod")
  .views((self) => ({
    get hasPrice() {
      return self.price !== null;
    },
  }));

export default PaymentMethod;
